<template>
  <div style="width: 100%; margin: 0 auto">
    <div class="body_top">
      <div class="bg_img_div">
        <!-- <img src="@/assets/newIndexBg.png" /> -->
      </div>
      <!-- 绝对定位 -->
      <div class="body_top_abs">
        <div class="img_he">
          <img class="log_Img" :src="require('@/assets/herder_logo1.png')" alt="" />
        </div>
        <p class="bt1">汇聚山西优质创作人 为您的品牌价值赋能</p>

        <div class="body_top_abs_gn">
          <div class="ag_select">
            <span v-for="index in bottomList" :key="index" :class="index.checked == true ? 'ag_selectT' : 'ag_selectF'"
              @click="selectClick(index)">{{ index.title }}</span>
          </div>
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input v-model="nickName" placeholder="输入创作者名称等进行搜索" @keyup.enter="seTmemberTypeId" />
              <div @click="seTmemberTypeId()" class="cur">
                <img src="../../assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
          </div>
          <div class="log_box">
            <!-- <img src="@/assets/log1.png" />
            <p>x</p>
            <img src="@/assets/log2.png" />
            <p>x</p>
            <img src="@/assets/log3.png" /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="body_main">
      <view style="display: block">
        <view class="worksClassify">
          <view>
            <view class="directionTitle">创作人</view>
            <view class="directionList">
              <span v-for="index in worksClassify" :key="index" v-show="index.parameter !== 'UNION' && index.parameter !== 'ALL'
                " @click="worksClassifyClick(index)" :class="index.checked == true ? 'directionListY cur' : 'cur'">{{
    index.title }}</span>
            </view>
          </view>
          <view style="margin-bottom: 0">
            <view class="directionTitle">类型</view>
            <view class="directionList">
              <span v-for="index in worksClassify2" :key="index" @click="worksClassifyClick2(index)"
                :class="index.checked == true ? 'directionListY cur' : 'cur'">{{ index.title }}</span>
            </view>
          </view>
        </view>
      </view>
      <!-- 数据展示 -->
      <el-row :gutter="20">
        <el-col :span="6" v-for="index in userList" :key="index" @click="composer(index)">
          <moduleHotComposer class="cur" :message="index"></moduleHotComposer>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination v-if="userList.length != 0" v-model:current-page="page.pageNum" v-model:page-size="page.pageSize"
        @size-change="sizeChange" @current-change="currentChange" style="margin: 0.4rem 0" background
        layout="prev, pager, next" :total="page.total" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import moduleHotComposer from "../../components/moduleHotComposer.vue";
const router = useRouter();
const composer = function (index) {
  // console.log(index.memberId);
  open("ShadowComposerHomepage?id=" + index.memberId, "_blank");
  // router.push({
  //   path: "/ShadowComposerHomepage",
  //   query: { id: index.memberId },
  // });
};
document.title = "标识山西-找创作人";
let pageDef = ref({
  pageNum: 1,
  pageSize: 8,
  total: 0,
});
const page = pageDef;
// =====分类=====
const worksClassify = ref([]);
const worksClassify2 = ref([]);

let userList = ref([]);
/* =====获取分类列表====== */
// 类型1
Axios("GET", "/member/member-type/types", false, false, function (res) {
  // console.log(res.data.data);
  worksClassify.value = [];
  let resList = res.data.data;
  for (let i = 0; i < resList.length; i++) {
    let index = {
      parameter: "",
      title: "",
      checked: "",
    };
    index.parameter = resList[i].dictValue;
    index.title = resList[i].dictLabel;
    if (i == 1) {
      index.checked = true;
      setLX2(index.parameter);
    } else {
      index.checked = false;
    }
    worksClassify.value.push(index);
  }
});
// 类型2
let setLX2 = function (index) {
  let params = {
    memberType: index,
  };
  Axios("GET", "/member/type/listby", params, false, function (res) {
    worksClassify2.value = [];
    let resList = res.data.data;
    let indexQB = {
      parameter: "",
      title: "全部",
      checked: true,
    };
    worksClassify2.value.push(indexQB);

    for (let i = 0; i < resList.length; i++) {
      let index = {
        parameter: "",
        title: "",
        checked: "",
      };
      // index.parameter = resList[i].memberType;
      index.parameter = resList[i].id;
      index.title = resList[i].memberClass;
      index.checked = false;
      worksClassify2.value.push(index);
    }
  });
};
let memberTypeId = ref(""); // 条件查询
let memberType = ref("CREATOR"); // 分类传参
let nickName = ref("");
let inputTitle = "";
router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("inputTitle")
    ? (inputTitle = router.currentRoute.value.query.inputTitle)
    : ""
  : "";

nickName.value = inputTitle || "";
// 默认获取列表
let getuserList = function () {
  // 获取 创作者列表
  let params = {
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
  };
  if (memberType.value != "" && memberType.value) {
    params["memberType"] = memberType.value;
  }
  if (memberTypeId.value != "" && memberTypeId.value) {
    params["memberTypeId"] = memberTypeId.value;
  }
  params.nickName = nickName.value;
  Axios("GET", "/member/front/list", params, false, function (res) {
    userList.value = res.data.rows;
    page.value.total = res.data.total;
  });
};
getuserList();

//类型1点击事件
// const worksClassifyiClick = function (index) {
//   for (let i = 0; i < worksClassify.value.length; i++) {
//     // console.log(worksClassify.value[i] == index);
//     if (worksClassify.value[i] == index) {
//       console.log(worksClassify.value[i])
//       worksClassify.value[i].checked = true;
//       setLX2(worksClassify.value[i].parameter);
//       memberType.value = worksClassify.value[i].parameter;
//       getuserList();
//     } else {
//       worksClassify.value[i].checked = false;
//     }
//   }
// };

//类型1点击事件
const worksClassifyClick = function (index) {
  console.log(worksClassify.value);
  for (let i = 0; i < worksClassify.value.length; i++) {
    console.log(worksClassify.value[i] == index);
    // console.log(worksClassify.value[i] == index);
    if (worksClassify.value[i] == index) {
      worksClassify.value[i].checked = true;
      setLX2(worksClassify.value[i].parameter);
      memberType.value = worksClassify.value[i].parameter;
      memberTypeId.value = null;
      getuserList();
    } else {
      worksClassify.value[i].checked = false;
    }
  }
};
//类型2点击事件
const worksClassifyClick2 = function (index) {
  for (let i = 0; i < worksClassify2.value.length; i++) {
    // console.log(worksClassify2.value[i] == index);
    if (worksClassify2.value[i] == index) {
      worksClassify2.value[i].checked = true;
      memberTypeId.value = worksClassify2.value[i].parameter;
      getuserList();
    } else {
      worksClassify2.value[i].checked = false;
    }
  }
};
// 搜索框事件
const seTmemberTypeId = function () {
  getuserList();
  window.scrollTo(0, 600);
};
const sizeChange = (val) => {
  getuserList();
};
const currentChange = (val) => {
  page.value.pageNum = val;
  getuserList();
};
const prevClick = (val) => {
  page.value.pageNum = val;
  getuserList();
};
const nextClick = (val) => {
  page.value.pageNum = val;
  getuserList();
};
</script>

<style lang="less" scoped>
/* @import url(../../../src/assets/css/com_element.css); */
.worksClassify {
  padding: 0.24rem 0.24rem 0;
  background: #f5f5f5;
  border-radius: 0.08rem;
  display: block;
  margin-top: 0.3rem;
}

.worksClassify>view {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 0.24rem;
}

.directionList {
  display: flex;
  flex-wrap: wrap;
}

.directionTitle {
  margin-right: 0.4rem;
  border-radius: 1rem 0rem 1rem 1rem;
  background: #c01a26;
  font-size: 0.14rem;
  color: #ffffff;
  padding: 0.06rem 0;
  text-align: center;
  display: block;
  width: 0.7rem;
  white-space: nowrap;
  flex: none;
}

.directionList span {
  width: 1rem;
  padding: 0.04rem 0;
  margin-right: 0.12rem;
  margin-bottom: 0.24rem;
  display: block;
  font-size: 0.14rem;
  color: #86909c;
  text-align: center;
}

.directionListY {
  background: rgba(41, 120, 255, 0.2);
  color: #c01a26 !important;
  border-radius: 1rem 1rem 1rem 1rem;
}

/* 公共提取 */
.el-pagination {
  justify-content: center;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #c01a26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #c01a26;
}

/deep/ .el-pagination.is-background .el-pager li.is-active {
  background: #c01a26;
}

/* 	/deep/.el-pagination.is-background .btn-next , .el-pagination.is-background .el-pager li , .el-pagination.is-background .btn-prev  {
		background:rgba(0,0,0,0);
	} */
.body_top {
  margin: 0 auto;
  position: relative;
  background: rgba(0, 0, 0, 0.3);
}

.body_main {
  display: block;
  width: 12.8rem;
  margin: 0 auto;
}

.bg_img_div {
  width: 100%;
  position: relative;
  // z-index: -1;
  // background: rgba(0, 0, 0, 0.3);
  height: 7rem;
  // overflow: hidden;
  // position: relative;
  background: url("../../assets/newIndexBg.png") no-repeat bottom center;
  background-size: auto 100%;
}

.bg_img_div>img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.body_top_abs {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.body_top_abs>.img_he {
  width: 100%;
  text-align: center;
  margin-top: 1.3rem;
}

.log_Img {
  text-align: center;
  width: 2.8rem;
}

.bt1 {
  margin-top: 0.1rem;
  color: #ffffff;
  font-size: 0.3rem;
  text-align: center;
}

.bt2 {
  margin-top: 0.08rem;
  font-size: 0.16rem;
  color: #ffffff;
  text-align: center;
}

.body_top_abs_gn {
  flex: 1;
  position: relative;
  width: 7.5rem;
  margin: 0 auto;
  margin-top: 0.9rem;
}

.ag_select {
  margin-bottom: 0.12rem;
}

.ag_select>span {
  margin-right: 0.4rem;
  color: #fff;
  font-size: 0.14rem;
  line-height: 0.16rem;
  padding-bottom: 0.03rem;
}

.ag_selectT {
  border-bottom: 0.02rem solid #fff;
}

.ag_selectY {
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0);
}

.ag_l {
  width: 100%;
  display: flex;
  justify-content: initial;
  align-items: center;
}

.ss_abs_c_srk {
  width: 8rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #c01a26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.log_box {
  position: absolute;
  bottom: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.6rem;
  width: 100%;

  img {
    // width: 1.2rem;
    height: 0.4rem;

    &:nth-of-type(2) {
      margin: 0 0.24rem;
    }
  }

  p {
    color: #fff;
    padding: 0 0.21rem;
  }
}
</style>
